import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  GetAIOCRSettings,
  UpdateAIOCRSettings
} from "../../../actions/AIOCRActions";
const AIOCRSettings = () => {
  const dispatch = useDispatch();
  const aiOCRInfo = useSelector((state) => state.aiOCRInfo.value);
  const [settings, updateSettings] = useState([]);
  const [screenHeight, updateScreenHeight] = useState(window.innerHeight - 140);
  useEffect(() => {
    if (!aiOCRInfo.loaded) {
      GetAIOCRSettings(dispatch);
    } else {
      updateSettings(aiOCRInfo.settings);
    }
  }, [aiOCRInfo]);
  const updateValue = (e, id) => {
    const newSettings = settings.map(
      (setting) => setting.settingId === id ? { ...setting, value: e.target.value } : setting
    );
    updateSettings(newSettings);
  };
  const saveAIOCRSettings = () => {
    UpdateAIOCRSettings(settings, dispatch);
  };
  const headerCellStyle = {
    textAlign: "left",
    padding: "10px",
    borderBottom: "2px solid #ccc",
    fontWeight: "bold",
    backgroundColor: "#f8f8f8"
  };
  const cellStyle = {
    padding: "10px",
    borderBottom: "1px solid #eee",
    verticalAlign: "top",
    wordBreak: "break-word"
  };
  return /* @__PURE__ */ React.createElement("div", { className: "flex-fill" }, /* @__PURE__ */ React.createElement("div", { className: "d-flex flex-column" }, /* @__PURE__ */ React.createElement("div", { className: "p-2", style: { backgroundColor: "rgba(0,0,0,0.03)", borderBottom: "solid 1px #CCC" } }, /* @__PURE__ */ React.createElement("div", { style: { float: "left", paddingTop: "10px" } }, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-gear" }), " AI OCR Settings"), /* @__PURE__ */ React.createElement("div", { style: { float: "right", marginTop: "-12px" } }, /* @__PURE__ */ React.createElement("div", { className: "col" }, /* @__PURE__ */ React.createElement(
    "button",
    {
      className: "btn btn-success mt-3",
      onClick: saveAIOCRSettings,
      style: { marginLeft: "30px" }
    },
    /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-save" }),
    " Save Changes"
  ))))), /* @__PURE__ */ React.createElement("div", { className: "flex-fill", style: { backgroundColor: "#FFF", height: `${screenHeight}px`, overflowY: "auto" } }, /* @__PURE__ */ React.createElement("div", { className: "container" }, /* @__PURE__ */ React.createElement(
    "div",
    {
      style: { maxWidth: "100%", margin: "12px" },
      id: "intakeInfo",
      className: "card"
    },
    /* @__PURE__ */ React.createElement(
      "table",
      {
        style: {
          width: "100%",
          borderCollapse: "collapse"
        }
      },
      /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", { style: headerCellStyle }, "Name"), /* @__PURE__ */ React.createElement("th", { style: headerCellStyle }, "Display"), /* @__PURE__ */ React.createElement("th", { style: headerCellStyle }, "Description"), /* @__PURE__ */ React.createElement("th", { style: headerCellStyle }, "Value"))),
      /* @__PURE__ */ React.createElement("tbody", null, settings.map((setting) => /* @__PURE__ */ React.createElement("tr", { key: setting.id }, /* @__PURE__ */ React.createElement("td", { style: cellStyle }, setting.settingName), /* @__PURE__ */ React.createElement("td", { style: cellStyle }, setting.display), /* @__PURE__ */ React.createElement("td", { style: cellStyle }, setting.description), /* @__PURE__ */ React.createElement("td", { style: cellStyle }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          value: setting.value,
          onChange: (e) => updateValue(e, setting.settingId),
          style: {
            width: "100%",
            padding: "5px",
            boxSizing: "border-box",
            fontSize: "1rem"
          }
        }
      )))))
    )
  ))));
};
export default AIOCRSettings;
